import * as React from "react";
import {useLayoutEffect, useState} from "react";
import PageWrapper from "~/common/layout/PageWrapper";
import PageContent from "~/common/layout/PageContent";
import PageContentWrapper from "~/common/layout/PageContentWrapper";
import SideMenu from "~/apps/pos/mobile/containers/common/SideMenu";
import SalesHeader from "~/apps/pos/mobile/containers/sales/SalesHeader";
import SaleHistory from "~/apps/pos/mobile/containers/sales/SaleHistory";
import PageMobileContent from "~/common/layout/PageMobileContent";

export default function (children = null) {
  const [width, setWidth] = useState(window.innerWidth);
  useLayoutEffect(() => {
    const updateWidth = () => {
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, [])

  const isDesktop : boolean = width > 767;
  if (isDesktop) {
    return (
      <React.Fragment>
        <PageWrapper>
          <SideMenu />
          <PageContent>
            <SalesHeader />
            <PageContentWrapper>
              <SaleHistory isDesktop />
            </PageContentWrapper>
            {children &&
            <div className="ol__cont ol--cent">
              <div className="card">
                {React.cloneElement(children, { isDesktop: true })}
              </div>
            </div>
            }
          </PageContent>
        </PageWrapper>
      </React.Fragment>
    )
  }

  if (children) {
    return children;
  }

  return (
    <React.Fragment>
      <PageMobileContent>
        <SaleHistory />
      </PageMobileContent>
    </React.Fragment>
  )
};
